const MVCObject = require("../mvcobject").MVCObject;

/**
 * @memberOf woosmap.location
 */
class NearbyStoresSource extends MVCObject {
    /**
     * Builds a NearbyStoresSource
     * @param {woosmap.DataSource} dataSource
     * @param {Number} maxStores maximum number of stores which will be retrieved from data source
     * @param {Number} maxDistanceFromUser the maximum distance from user in meters
     */
    constructor(dataSource, maxStores, maxDistanceFromUser) {
        super();
        /**
         * An array of stores. This property is bindable.
         * @see woosmap.utils.MVCObject#bindTo
         * @type {Array}
         */
        this.stores = null;
        this.dataSource = dataSource;
        /**
         * The location to search stores from. This property is bindable.
         * @see woosmap.utils.MVCObject#bindTo
         * @type {LatLngLiteral}
         */
        this.location = null;
        this.maxStores = maxStores;
        this.maxDistanceFromUser = maxDistanceFromUser;
    }

    /**
     * This method is called when the location has changed.
     */
    location_changed() {
        const location = this.get("location");
        this.dataSource.getNearbyStores(
            location.lat,
            location.lng,
            (geojson) => {
                this.set("stores", geojson.features);
            },
            this.maxStores,
            this.maxDistanceFromUser,
        );
    }
}

exports.NearbyStoresSource = NearbyStoresSource;
